import { render, staticRenderFns } from "./PlusSquareIcon.vue?vue&type=template&id=7386d97d&scoped=true"
import script from "./PlusSquareIcon.vue?vue&type=script&lang=js"
export * from "./PlusSquareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7386d97d",
  null
  
)

export default component.exports